export function headerLogo() {
  const homeOffsetTop = 70
  const headerOffsetTop = 20

  const scroller = () => {
    const scTop =(document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop
    if (headerOffsetTop < scTop) {
      document.body.classList.add('is-header-logo-small')
      if (homeOffsetTop < scTop) {
        document.body.classList.add('is-home-header')
      } else {
        document.body.classList.remove('is-home-header')
      }
    } else {
      document.body.classList.remove('is-header-logo-small','is-home-header')
    }
  }

  window.addEventListener('resize', scroller)
  window.addEventListener('scroll', scroller, { passive: true })

  try {
    Typekit.load({
      loading: function () {},
      active: function () {
        scroller()
      },
      inactive: function () {},
    })
  } catch (e) {}

  setInterval(() => {
    scroller()
  }, 1000)

  scroller()
}
